module.exports = "/_next/static/images/349515e39a0a872a016548f1ff1fb4c6-hero-xs.png";